import { Box } from "@mui/material";
import FilterHdrIcon from "@mui/icons-material/FilterHdr";
import { EffectOption } from "./widgets";
import { VideoBackgroundBlurEffectParams } from "conference/components/meeting-page/types";
import { useSettings } from "conference/components/meeting-page/tools";
import { defineMessages } from "react-intl";

type Props = {
    level: VideoBackgroundBlurEffectParams["level"];
};

const blurLevelMessages = defineMessages({
    light: { id: "videoBackgroundEffect.light", defaultMessage: "Light blur" },
    strong: { id: "videoBackgroundEffect.strong", defaultMessage: "Strong blur" },
});

const BlurOption = ({ level }: Props) => {
    const settings = useSettings();
    const filterBlur = level === "light" ? 1 : 2;
    const params = settings.videoBackgroundEffect.params;

    const select = () => {
        settings.videoBackgroundEffect = {
            type: "blur",
            params: {
                level,
            },
        };
    };

    return (
        <EffectOption label={blurLevelMessages[level]} onClick={select} selected={params?.level === level}>
            <Box sx={{ position: "relative" }}>
                <FilterHdrIcon fontSize="large" style={{ filter: `blur(${filterBlur}px)` }} />
            </Box>
        </EffectOption>
    );
};

export default BlurOption;
